$(->
  # TODO: (8/8/17, charis@careerplug.com) I'm not entirely sure if this is still active code, or if it belongs in shared.
  # This should be investigated further.
  if $('#account_copy_agency_overview').length > 0
    $('#account_submit_action').click (ev)->
      unless tinymce.get('account_agency_overview').isDirty()
        return true
      ev.preventDefault()
      for ed in tinymce.editors
        ed.save()
        ed.isNotDirty = 1
      m = window.get_modal_markup()
      buttons = """
                <button type="button" class="btn btn-default no">No</button>
                <button type="button" class="btn btn-primary yes">Yes</button>
                """
      m.html(window.get_modal_content('Copy Agency Overview?', '<p>Would you like to use this Agency Overview for Aspirants as your Overview for your CareerPlug Jobs Page as well?</p>', buttons))

      m.find('.modal-footer button.no').click ->
        $('#account_copy_agency_overview').closest('form').submit()
      m.find('.modal-footer button.yes').click ->
        $('#account_copy_agency_overview').val('1')
        $('#account_copy_agency_overview').closest('form').submit()

      m.modal()
      false
)
